/**
 * view_X and view_any_X are treated as one privilege in the UI.
 */

export const isViewAnySlug = (slug = "") =>
  typeof slug === "string" && slug.startsWith("view_any_");

export const twinPrivilegeSlug = (slug = "") => {
  if (isViewAnySlug(slug)) {
    return `view_${slug.slice("view_any_".length)}`;
  }
  if (typeof slug === "string" && slug.startsWith("view_")) {
    return `view_any_${slug.slice("view_".length)}`;
  }
  return null;
};

/** True if admin has slug OR its view/view_any twin. */
export const privilegeMatches = (privileges = [], slug) => {
  if (!Array.isArray(privileges) || !slug) return false;
  if (privileges.includes(slug)) return true;
  const twin = twinPrivilegeSlug(slug);
  return twin ? privileges.includes(twin) : false;
};

/** Hide view_any_* from the privilege multi-select. */
export const filterVisiblePrevileges = (previleges = []) =>
  (previleges || []).filter((p) => !isViewAnySlug(p?.slug));

/**
 * When admin has only view_any_X, show view_X in the select instead.
 */
export const toVisibleSelectedPrevileges = (owned = [], allPrevileges = []) => {
  const bySlug = Object.fromEntries(
    (allPrevileges || []).filter((p) => p?.slug).map((p) => [p.slug, p])
  );
  const seen = new Set();
  const result = [];

  for (const p of owned || []) {
    let target = p;
    if (isViewAnySlug(p?.slug)) {
      const twin = bySlug[twinPrivilegeSlug(p.slug)];
      if (twin) target = twin;
      else continue;
    }
    if (!target?.id || seen.has(target.id)) continue;
    seen.add(target.id);
    result.push({ value: target.id, label: target.name });
  }
  return result;
};

/**
 * On save: if view_X is selected, also attach view_any_X id.
 */
export const expandPrevilegeIds = (selectedIds = [], allPrevileges = []) => {
  const byId = Object.fromEntries(
    (allPrevileges || []).map((p) => [String(p.id), p])
  );
  const bySlug = Object.fromEntries(
    (allPrevileges || []).filter((p) => p?.slug).map((p) => [p.slug, p])
  );
  const result = new Set();

  for (const id of selectedIds) {
    if (id === "FULL_ACCESS") continue;
    result.add(id);
    const p = byId[String(id)];
    if (!p?.slug || isViewAnySlug(p.slug)) continue;
    if (p.slug.startsWith("view_")) {
      const twin = bySlug[twinPrivilegeSlug(p.slug)];
      if (twin?.id != null) result.add(twin.id);
    }
  }
  return [...result];
};
